import gql from "graphql-tag";

export const GET_ATTACHMENT = gql`
	query GetAttachment($key: String!) {
		attachment(input: { key: $key })
	}
`;
